import { PublicSharedApiService } from '../public-shared-api.service';
import { endpoint } from '../shared-api.service';

const publicSharedApi = new PublicSharedApiService(endpoint);
export const linkSsoSignInToUser = async (email: string, awsIdentityProviderKey: string) => {
  const trimmed = email.trim();
  if (trimmed === '') {
    return null;
  }

  return publicSharedApi.create<void>({
    path: 'link-ogp-to-sso',
    body: {
      email,
      awsIdentityProviderKey,
    },
  });
};
